import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Loader } from "semantic-ui-react";
import PropTypes from "prop-types";
import { sliceList } from "../../helpers/filter";
import { Pagination } from "../common/pagination";
import { ChargeTable } from "./charge-table";
import { Link } from "react-router-dom";
import { reverse, routes } from "../../routes";
import { t } from "../../constant/translations";

const ChargeHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PaginationWrapper = styled.div`
  margin: 1em 0;
  width: 100%;
`;

export const ChargeListComponent = ({
  charges,
  loading,
  estate,
  error,
  clearError,
  fetchCharges,
  deleteCharge,
  editCharge,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    fetchCharges(estate.id);
  }, [estate.id, fetchCharges]);

  const handlePaginate = (newCurrentPage, newPageSize) => {
    setCurrentPage(newCurrentPage);
    setPageSize(newPageSize);
  };

  if (!charges) {
    return <Loader active={true} />;
  }

  const page = sliceList(charges, currentPage - 1, pageSize);
  const chargeListURL = reverse(routes.blockChargeList, {
    blockId: estate.block.id,
  });

  return (
    <div>
      <ChargeHeader>
        <PaginationWrapper>
          <Pagination
            current={currentPage}
            total={charges.length}
            onChange={handlePaginate}
            pageSize={pageSize}
          />
          <Link
            to={`${chargeListURL}?vendor_id=${estate.vendor_id}`}
            style={{ float: "right" }}
          >
            {t("labels.toall")}
          </Link>
        </PaginationWrapper>
      </ChargeHeader>
      <ChargeTable
        estate={estate}
        charges={page}
        editCharge={editCharge}
        deleteCharge={deleteCharge}
        loading={loading}
        error={error}
      />
    </div>
  );
};

ChargeListComponent.propTypes = {
  charges: PropTypes.array,
  loading: PropTypes.bool,
  estate: PropTypes.object.isRequired,
  error: PropTypes.object,
  clearError: PropTypes.func,
  fetchCharges: PropTypes.func.isRequired,
  deleteCharge: PropTypes.func,
  editCharge: PropTypes.func,
};
